<template>
  <div class="slider">
    <div class="container-slider">
      <div class="liveApp" v-if="!loading">
        <div class="images">
          <div class="single_slide"
               v-for="(image, index) in roomPictures"
               :key="image.absolute_path"
               :index="index"
               :item="image"
               :class="{ active: index === currentIndex }">
            <div class="imgslider">
              <div class="slider_image" :class="{loaded: isLoaded(index)}">
                <img :src="`${image.absolute_path}?w=${Math.min(window.innerWidth, 1920)}&h=550&crop-to-fit`" v-on:load="handleIndexLoaded(index)"/>
              </div>
              <div class="txtslide">
                <h2 v-if="homeSliderTexts[index % homeSliderTexts.length].lines.length > 0">{{homeSliderTexts[index %
                  homeSliderTexts.length].lines[0]}}</h2>
                <h3 v-if="homeSliderTexts[index % homeSliderTexts.length].lines.length > 1">{{homeSliderTexts[index %
                  homeSliderTexts.length].lines[1]}}</h3>
                <h3 v-if="homeSliderTexts[index % homeSliderTexts.length].lines.length > 2">{{homeSliderTexts[index %
                  homeSliderTexts.length].lines[2]}}</h3>
              </div>
              <div class="gradientslider"></div>
            </div>
          </div>
        </div>
        <ul class="dots">
          <li
            v-for="(image, index) in roomPictures"
            :class="{ active: index === currentIndex }"
            @click="goto(index)"
            v-on:mouseover="stopRotation"
            v-on:mouseout="startRotation"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'home-slider',
    data() {
      return {
        interval: null,
        size: "",
        window: window,
        loaded: [],
        rotationCount: 0
      };
    },
    async created() {
      await this.$store.commit('homeSlider/SET_PICTURES');
      await this.$store.commit('homeSlider/SET_INDEX', 0);
      await this.$store.dispatch('homeSlider/fetch', {lang: this.$store.state.lang.currentLang});
    },
    mounted() {
      this.size += window.innerWidth;
    },
    async beforeDestroy() {
      await this.$store.commit('homeSlider/SET_INDEX', 0);
      await this.$store.commit('homeSlider/SET_PICTURES');
      clearInterval(this.$data.interval);
    },
    methods: {
      goto(index) {
        this.$store.dispatch('homeSlider/goIndex', index);
      },
      isLoaded (index) {
        return this.loaded.slice(0, index + 1).reduce((c, p) => (c && p), true)
          && (
            (index === 0 || this.currentIndex > 0)
            || (
              this.currentIndex === 0
              && index === this.roomPictures.length - 1 && this.rotationCount > 0
            )
          );
      },
      startRotation() {
        if (this.$data.interval) {
          return;
        }
        this.$data.interval = setInterval(() => {
          this.rotationCount += 1;
          this.increment();
        }, this.duration);
      },
      stopRotation() {
        if (!this.$data.interval) {
          return;
        }
        clearInterval(this.$data.interval);
        this.$data.interval = null;
      },
      increment(v = 1) {
        if (this.loaded.length === 0) return;
        let nextIndex = (this.currentIndex + v) % this.roomPictures.length;
        if (this.loaded[nextIndex] === false) return;
        this.$store.dispatch('homeSlider/goIndex', nextIndex);
      },
      handleIndexLoaded (index) {
        this.loaded[index] = true;
        if (this.loaded.reduce((c,p) => (!!c && p), true)) {
          this.$forceUpdate();
          this.startRotation();
        }
      }
    },
    watch: {
      pictures () {
        this.loaded = [];
        this.rotationCount = 0;
        for (let i=0; i<this.roomPictures.length; i++) this.loaded.push(false);
      },

    },
    computed: mapState({
      roomPictures: state => state.homeSlider.roomPictures,
      homeSliderTexts: state => state.homeSlider.homeSliderTexts,
      loading: state => state.homeSlider.loading,
      duration: state => state.homeSlider.duration,
      currentIndex: s => s.homeSlider.currentIndex,
    }),
  };
</script>

<style scoped>
  .slider_image:not(.loaded) {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home-slider.vue